import { helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (_, core) => ({
  collapseContainer: {
    padding: 0,
    '& .helpbutton': helpbuttonStyle(core)['.helpbutton'],
    '& .helpbutton::before': helpbuttonStyle(core)['.helpbutton::before'],
    position: 'relative',
    '& .fixed-collapse-panel': {
      paddingTop: '8px',
      marginBottom: '8px',
      position: 'relative',
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
      borderRadius: '2px',
      backgroundColor: `${core && core.palette && core.palette.white}`,
    },
    '& .collapse-panel': {
      marginBottom: '8px',
      position: 'relative',
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
      borderRadius: '2px',
      backgroundColor: `${core && core.palette && core.palette.white}`,
    },
    '& .collapse-content': {
      wordWrap: 'break-word',
      '&.content-hide': {
        height: '0',
        marginBottom: '0',
        visibility: 'hidden',
      },
      '&.content-show': {
        height: 'auto',
        marginBottom: '24px',
      },
      '& .error': {
        wordWrap: 'normal',
      },
    },
    '& .collapse-content-details': {
      '&.details-hide': {
        display: 'none',
      },
    },
    '& .collapse-content-overflow-hidden': {
      overflow: 'hidden',
    },
    '& .collapse-content-position-relative': {
      position: 'relative',
    },
    '& .collapse-title-bar': {
      minHeight: '72px',
      position: 'relative',
      userSelect: 'none',
      padding: '24px 0',
      '& .title-item': {
        overflow: 'hidden',
      },
      '& .collapse-title, & .collapse-title label, & .collapse-title label span': {
        fontSize: '18px',
        marginBottom: 0,
        padding: 0,
        lineHeight: '24px',
        '& .helpbutton': {
          verticalAlign: 'initial',
        },
      },
      '& .collapse-title label': {
        marginLeft: '9px',
      },
      '& .inactive-text': {
        color: `${core && core.palette && core.palette.neutralTertiary}`,
      },
      '& .error-string-wrapper': {
        position: 'absolute',
        right: '46px',
      },
    },


    '& .hide': {
      display: 'none',
    },
  },
});

